/*
 * Copyright (C) 2024 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { EMPTY_STRING } from '@common/tech-shared';

import { Component, Input } from '@angular/core';
import { IconComponent } from '../../icon/icon.component';

@Component({
  selector: 'ods-error-message',
  imports: [IconComponent],
  host: { class: 'flex text-error my-2 text-sm items-center font-medium' },
  template: `<ods-icon name="exclamation" class="mr-1" fill="error" />
    <div class="grow wrap-break-word" [attr.id]="messageId">
      {{ text }}
      @if (subText) {
        <br aria-hidden="true" />
      }
      {{ subText }}
    </div>`,
})
export class ErrorMessageComponent {
  @Input() messageId: string = EMPTY_STRING;
  @Input({ required: true }) text!: string;
  @Input() subText: string = '';
}
